"use client";

import { useEffect } from "react";

/** Отправляет падения браузера в общий журнал (.run/errors.log).
 *
 * Ловим и обычные ошибки, и необработанные отказы промисов — второе как раз то,
 * что чаще всего проглатывалось: неудачный fetch внутри .then() не оставлял следа. */
export function ErrorReporter() {
  useEffect(() => {
    const seen = new Set<string>(); // одна и та же ошибка в цикле не должна спамить журнал
    const send = (where: string, msg: string, trace?: string) => {
      const key = `${where}|${msg}`.slice(0, 200);
      if (seen.has(key)) return;
      seen.add(key);
      // keepalive: отчёт уходит, даже если страница закрывается прямо сейчас
      fetch("/api/client-error", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ where, msg, trace, url: location.pathname + location.search }),
        keepalive: true,
      }).catch(() => {});
    };

    const onError = (e: ErrorEvent) => {
      send(
        `браузер ${e.filename ? e.filename.split("/").pop() : ""}`.trim(),
        e.message || "ошибка сценария",
        e.error?.stack,
      );
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      const r = e.reason as { message?: string; stack?: string } | string | undefined;
      send(
        "браузер: необработанный отказ",
        typeof r === "string" ? r : (r?.message ?? String(r)),
        typeof r === "object" ? r?.stack : undefined,
      );
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
